module.exports = __webpack_public_path__ + "img/horizontal_4_3_r_8004.bb5fe8b4.png";